import SiteHeader from "@/pages/home/components/SiteHeader";
import HeroSection from "@/pages/home/components/HeroSection";
import LatestUpdates from "@/pages/home/components/LatestUpdates";
import CompletedZone from "@/pages/home/components/CompletedZone";
import RankBoard from "@/pages/home/components/RankBoard";
import EditorPicks from "@/pages/home/components/EditorPicks";
import GenreGrid from "@/pages/home/components/GenreGrid";
import ReadingGuide from "@/pages/home/components/ReadingGuide";
import FaqSection from "@/pages/home/components/FaqSection";
import SiteFooter from "@/pages/home/components/SiteFooter";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <SiteHeader />
      <main>
        <HeroSection />
        <LatestUpdates />
        <CompletedZone />
        <RankBoard />
        <EditorPicks />
        <GenreGrid />
        <ReadingGuide />
        <FaqSection />
      </main>
      <SiteFooter />
    </div>
  );
}